export default __webpack_public_path__ + "static/pastry-3-d2360b359b7713a7ada894d32bba4e50.jpg";